import { findFirstMatchingSkillCommand } from '../../../../lib/skill-command-utils';
import type { SkillCommand } from '../../../../lib/skill-constants';

interface EntityMatch {
  start: number;
  end: number;
}

export function getSkillCommandEntityMatch(text: string, commands: SkillCommand[]): EntityMatch | null {
  const matchedCommand = findFirstMatchingSkillCommand(text, commands);

  if (!matchedCommand) {
    return null;
  }

  return {
    start: matchedCommand.startIndex,
    end: matchedCommand.endIndex,
  };
}

export function getHandleFromCommandEntityText(text: string): string {
  return text.trim().replace(/^\/+/, '');
}

export function splitPromptTextLines(text: string): string[] {
  return text.split(/\r\n|\r|\n/);
}
